export const getQP = (input: string | string[] | undefined): string | null => {
    if (input === undefined) {
        return null
    }
    if (Array.isArray(input)) {
        if (input.length >= 1) {
            return input[0]
        }
        return null
    }
    return input
}

export const normalizeQueryParam = (param: string | string[] | undefined): string | undefined => {
    if (param === undefined) {
        return undefined
    }
    if (Array.isArray(param)) {
        return param[0]
    }
    return param
}
